import { render, staticRenderFns } from "./AddNewOwner.vue?vue&type=template&id=0f564628&scoped=true&lang=html&"
import script from "./AddNewOwner.vue?vue&type=script&lang=js&"
export * from "./AddNewOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f564628",
  null
  
)

export default component.exports